import React, { useState } from "react";
import "./styles.scss";
import { Button, FormHeader, TextArea } from "../../components";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { getLanguage } from "../../utils/environment";
import { useDispatch } from "react-redux";
import { CheckValidity } from "../../utils";
import { getAllNewsUrls } from "./services/siteMap.service";

const lan = getLanguage();

const SiteMap = () => {
  const [formData, setFormData] = React.useState({
    urlTextArea: {
      key: "urlTextArea",
      label: "",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "Fetch news urls",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const handleChange = async (event, inputIdentity) => {
    const updateContactForm = {
      ...formData,
    };

    updateContactForm[inputIdentity].value = event;

    let validityRes = await CheckValidity(
      inputIdentity,
      updateContactForm[inputIdentity].value,
      updateContactForm[inputIdentity].validation
    );
    console.log(updateContactForm.firstName.value);
    if (validityRes) {
      updateContactForm[inputIdentity].isValid = validityRes.isValid;
      updateContactForm[inputIdentity].invalidReason = validityRes.reason;
      updateContactForm[inputIdentity].touched = true;
      // updateContactForm[inputIdentity] = updatedFormElement;
      let formIsValid = false;
      for (let inputIdentifier in updateContactForm) {
        formIsValid = updateContactForm[inputIdentifier].valid && formIsValid;
      }

      setFormData(updateContactForm);
    }
  };

  const onClickGetAllNewsUrls = async () => {
    setIsLoading(true);
    try {
      setFormData({ urlTextArea: { ...formData.urlTextArea, value: "" } });
      let resOffers = await getAllNewsUrls();
      console.log("resOffers", resOffers);
      if (resOffers?.data?.status) {
        setIsLoading(false);
        setFormData({
          urlTextArea: {
            ...formData.urlTextArea,
            value: resOffers?.data?.data?.toString().replace(/,/g, "\n"),
          },
        });
      }
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  const formatUrls = (input) => {
    const urls = input.split(","); // Split the string by commas
    const formattedUrls = urls.map((url) => `'${url.trim()}'`); // Trim whitespace and wrap in single quotes
    return formattedUrls.join(",\n    "); // Join with comma and proper indentation
  };

  const handleCopy = async () => {
    try {
      const updateFormData = { ...formData };
      await navigator.clipboard.writeText(
        formatUrls(updateFormData.urlTextArea.value)
      );
      alert("Copied!");
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleDownloadXML = (urlsString) => {
    const urls = urlsString.split(",").map((url) => url.trim());

    const xmlContent = `<?xml version="1.0" encoding="UTF-8"?>
            <urlset>
            ${urls.map((url) => `  <url>${url}</url>`).join("\n")}
            </urlset>`;

    const blob = new Blob([xmlContent], { type: "application/xml" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "sitemap.xml";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const updateFormData = { ...formData };

  return (
    <>
      <div className="hne-jb-category-wrapper">
        <div className="col-12 jb-category-body-wrapper">
          <FormHeader
            data={{
              formHeader: "Site Map",
              size: "md-md",
            }}
          />
          <div className="d-flex flex-row justify-content-between align-items-center">
            <div>
              <Button
                data={{
                  mainLayerStyles: "",
                  btnName: "Fetch Urls",
                  buttonType: "primary",
                  buttonSize: "sm x",
                  isLoading: isLoading,
                  disable: false,
                }}
                onClick={async (e) => {
                  e.preventDefault();
                  await onClickGetAllNewsUrls(e);
                }}
              />
            </div>
            <div className="jchw-category">
              <Button
                data={{
                  mainLayerStyles: "",
                  btnName: "Copy Urls",
                  buttonType: "secondary border",
                  buttonSize: "sm x",
                  disable:
                    updateFormData.urlTextArea.value === "" ? true : false,
                }}
                onClick={async (e) => {
                  e.preventDefault();
                  await handleCopy(e);
                }}
              />
            </div>
          </div>
          <div className="hne-jb-category-body-wrapper">
            <TextArea
              data={updateFormData.urlTextArea}
              onChange={async (e) => {
                e.preventDefault();
                await handleChange(
                  e.target.value,
                  updateFormData.urlTextArea.key
                );
              }}
            />
          </div>
          <div>
            <Button
              data={{
                mainLayerStyles: "",
                btnName: "Download XML",
                buttonType: "secondary border",
                buttonSize: "sm x",
                disable: updateFormData.urlTextArea.value === "" ? true : false,
              }}
              onClick={async (e) => {
                e.preventDefault();
                handleDownloadXML(updateFormData.urlTextArea.value);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default withRouter(SiteMap);
